<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon class="bright" points="6,11 10,6 7,6 7,1 5,1 5,6 2,6" />
</svg>
</template>